import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import { Button } from '@mui/material'

const TopicUpdateForm = React.lazy(() => loadComponent('certification', 'TopicUpdateForm'))

export function CertificationTopicUpdateRoute() {
    const params = useParams()
    const navigate = useNavigate()
    const { academy, openFlightDeck } = useFlightDeck()

    const canUpdate = usePermission('certification.topic.update', { academy: academy?._id! })
    const canDelete = usePermission('certification.topic.delete', { academy: academy?._id! })

    const onDelete = useCallback(() => {
        navigate('/certificate_topics')
    }, [navigate])

    const onUpdate = useCallback(() => {
        navigate('/certificate_topics')
    }, [navigate])

    return (
        <RouteContainer>
            {!academy ? (
                <>
                    <GenericNotice
                        title="Keine Akademie ausgewählt"
                        message="Fragenpools gehören immer zu einer Akademie. Bitte wähle eine Akademie im Flight Deck aus, um dessen Fragenpools zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <TopicUpdateForm
                    _id={params._id}
                    academyId={academy?._id}
                    canDelete={canDelete}
                    canUpdate={canUpdate}
                    onDelete={onDelete}
                    onUpdate={onUpdate}
                />
            )}
        </RouteContainer>
    )
}
